import React, { useState } from "react";
import {
  GenericBarChart,
  KPICard,
  GroupedStackedBarChart,
  ProjectExplorer,
  BillingExplorer,
} from "./Components";
import { RoleValidator } from "../../Components/Common";
import { ROLES } from "../../Constants/Strings";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("all");

  return (
    <div className="px-3 py-2 min-h-screen mt-2">
      <div className="flex justify-between">
        <h1 className="text-2xl font-bold mb-4">Dashboard</h1>
        <div className="flex flex-wrap text-sm font-medium h-min text-center border rounded-lg overflow-hidden shadow-sm">
          <button
            onClick={() => setActiveTab("all")}
            className={`px-5 py-1 transition-all h-min duration-200 ${
              activeTab === "all"
                ? "bg-primary text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-900 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white"
            }`}
          >
            All Projects
          </button>
          <RoleValidator
            allowedRoles={[
              ROLES.SITE_ENGINEER,
              ROLES.PROJECT_MANAGER,
              ROLES.PROJECT_ENGINEER,
            ]}
          >
            <button
              onClick={() => setActiveTab("my")}
              className={`px-5 py-1 transition-all h-min duration-200 ${
                activeTab === "my"
                  ? "bg-primary text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-900 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white"
              }`}
            >
              My Projects
            </button>
          </RoleValidator>
        </div>
      </div>

      {/* Example sections */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <KPICard filter={activeTab} />
        <div className="p-4 bg-white shadow rounded">
          <GenericBarChart filter={activeTab} />
        </div>
        <div className="p-4 bg-white shadow rounded">
          <ProjectExplorer filter={activeTab} />
        </div>
        <div className="p-4 bg-white shadow rounded">
          <GroupedStackedBarChart filter={activeTab} />
        </div>
        <div className="p-4 bg-white shadow rounded">
          <BillingExplorer filter={activeTab} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
